export const targetGroupsByVersionConstants = {
  TARGET_GROUPS_BY_VERSION_LOADING: "TARGET_GROUPS_BY_VERSION_LOADING",
  TARGET_GROUPS_BY_VERSION_SUCCESS: "TARGET_GROUPS_BY_VERSION_SUCCESS",
  TARGET_GROUPS_BY_VERSION_FAILURE: "TARGET_GROUPS_BY_VERSION_FAILURE",
};

export const createTargetGroupsByVersionConstants = {
  CREATE_TARGET_GROUPS_BY_VERSION_LOADING:
    "CREATE_TARGET_GROUPS_BY_VERSION_LOADING",
  CREATE_TARGET_GROUPS_BY_VERSION_SUCCESS:
    "CREATE_TARGET_GROUPS_BY_VERSION_SUCCESS",
  CREATE_TARGET_GROUPS_BY_VERSION_FAILURE:
    "CREATE_TARGET_GROUPS_BY_VERSION_FAILURE",
};

export const editTargetGroupsByVersionConstants = {
  EDIT_TARGET_GROUPS_BY_VERSION_LOADING:
    "EDIT_TARGET_GROUPS_BY_VERSION_LOADING",
  EDIT_TARGET_GROUPS_BY_VERSION_SUCCESS:
    "EDIT_TARGET_GROUPS_BY_VERSION_SUCCESS",
  EDIT_TARGET_GROUPS_BY_VERSION_FAILURE:
    "EDIT_TARGET_GROUPS_BY_VERSION_FAILURE",
};

export const deleteTargetGroupsByVersionConstants = {
  DELETE_TARGET_GROUPS_BY_VERSION_LOADING:
    "DELETE_TARGET_GROUPS_BY_VERSION_LOADING",
  DELETE_TARGET_GROUPS_BY_VERSION_SUCCESS:
    "DELETE_TARGET_GROUPS_BY_VERSION_SUCCESS",
  DELETE_TARGET_GROUPS_BY_VERSION_FAILURE:
    "DELETE_TARGET_GROUPS_BY_VERSION_FAILURE",
};

export const addTargetGroupsByVersionConstants = {
  ADD_TARGET_GROUPS_BY_VERSION_LOADING: "ADD_TARGET_GROUPS_BY_VERSION_LOADING",
  ADD_TARGET_GROUPS_BY_VERSION_SUCCESS: "ADD_TARGET_GROUPS_BY_VERSION_SUCCESS",
  ADD_TARGET_GROUPS_BY_VERSION_FAILURE: "ADD_TARGET_GROUPS_BY_VERSION_FAILURE",
};

export const removeTargetGroupsByVersionConstants = {
  REMOVE_TARGET_GROUPS_BY_VERSION_LOADING:
    "REMOVE_TARGET_GROUPS_BY_VERSION_LOADING",
  REMOVE_TARGET_GROUPS_BY_VERSION_SUCCESS:
    "REMOVE_TARGET_GROUPS_BY_VERSION_SUCCESS",
  REMOVE_TARGET_GROUPS_BY_VERSION_FAILURE:
    "REMOVE_TARGET_GROUPS_BY_VERSION_FAILURE",
};
